import React, { useEffect, useState } from "react";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus, faChevronCircleLeft } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import { useNavigate, useLocation } from "react-router-dom";
import { SERVER_BASE } from "../config/server";
import apiClient from "../utils/apiClient";

const UnusableProduction = ({ accessOfDepartments }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const editData = location?.state?.editData;
    const [editId, setEditId] = useState(null);
    const token = localStorage.getItem("token");
    const code = localStorage.getItem("code");
    const sewadarId = localStorage.getItem("sewadarId");
    const [departments, setDepartments] = useState([]);
    const [selectedDept, setSelectedDept] = useState(null);
    const [date, setDate] = useState("");
    const [remarks, setRemarks] = useState("");
    const [locations, setLocations] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [itemOptions, setItemOptions] = useState([]);
    const [productionItems, setProductionItems] = useState([{ item: null, quantity: "", remarks }]);
    useEffect(() => {
        if (accessOfDepartments) {
            const deptArray = accessOfDepartments
                .split(',')
                .map((dept) => ({ value: dept.trim(), label: dept.trim() }));
            setDepartments(deptArray);
        }
    }, [accessOfDepartments]);
    // Handle Edit Mode
    const handleEdit = (data) => {

        setEditId(data.id);
        setSelectedDept({ label: data?.department, value: data?.department });
        setSelectedLocation({ label: data?.location, value: data?.location });
        setDate(data?.date)
        setRemarks(data?.remarks)
        setProductionItems(
            (data.productionItems || []).map((p) => ({
                item: {
                    value: p.itemName,
                    itemId: p.itemId,
                    label: p.itemName,
                    uom: p.uom,
                },
                quantity: p.quantity,
                remarks: p.remarks,
            }))
        );
    };

    useEffect(() => {
        if (editData) {
            handleEdit(editData);
        }
    }, [editData]);

    // Fetch Item Options
    const fetchItemOptions = async () => {
        try {
            const response = await apiClient.get(`${SERVER_BASE}/getSelectiveGroupItem`, {
                params: {
                    code,
                    groupCode:['X']
                },
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            setItemOptions(response.data.map((item) => ({
                value: item.printName,
                label: `${item.printName}${item.additionalNames ? ` - [ ${item.additionalNames} ]` : ''}`,
                itemId: item.id,
                itemCode: item.itemCode,
                uom: item.uom,
                unit: item.unit,
            })));
        } catch (error) {
            console.error('Error fetching item options:', error.message);
            console.error('Details:', error.response?.data || error.message);
        }
    };
    const fetchLocations = () => {
        apiClient
            .get(SERVER_BASE + "/getLocations", {
                params: { code }, headers: {
                    Authorization: `Bearer ${token}`, // Add the JWT token in the header
                }
            })
            .then((response) =>
                setLocations(
                    response.data.map((location) => ({
                        value: location.location,
                        label: location.location,
                    }))
                )
            )
            .catch((error) => console.error(error));
    };
    useEffect(() => {
        fetchLocations();
        fetchItemOptions();
    }, []);

    const handleItemsChange = (index, field, value) => {
        const updated = [...productionItems];
        if (field === "item") {
            if (productionItems.some((f, i) => i !== index && f.item?.value === value?.value)) {
                Swal.fire({
                    toast: true,
                    icon: "warning",
                    title: "This item is already selected",
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                });
                return;
            }
        }
        updated[index][field] = value;
        setProductionItems(updated);
    };

    // Add/Remove Rows
    const addRow = () => setProductionItems([...productionItems, { item: null, quantity: "" }]);
    const removeRow = (index) => {
        if (productionItems.length === 1) return;
        setProductionItems(productionItems.filter((_, i) => i !== index));
    };

    // Submit Handler
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!selectedDept) {
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'warning',
                title: 'Please select department',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
            });
            return;
        }
        if (!selectedLocation) {
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'warning',
                title: 'Please select location',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
            });
            return;
        }
        if (productionItems.some((f) => !f.item || !f.quantity)) {
            Swal.fire({
                toast: true,
                icon: "warning",
                title: "Items and quantities are required in all rows",
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
            });
            return;
        }

        const payload = {
            productionItems: productionItems.map((p) => ({
                itemId: p.item.itemId,
                itemName: p.item.value,
                quantity: p.quantity,
                uom: p.item.uom,
            })),
            prodDate:date,
            remarks,
            createdBy: sewadarId,
            department: selectedDept?.value,
            location: selectedLocation?.value,
            centerCode: code
        };

        try {
            if (editId) {
                await apiClient.put(`${SERVER_BASE}/updateUnusableProduction/${editId}`, payload, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                Swal.fire({
                    toast: true,
                    icon: "success",
                    title: "Production updated successfully",
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                });
            } else {
                await apiClient.post(`${SERVER_BASE}/saveUnusableProduction`, payload, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                Swal.fire({
                    toast: true,
                    icon: "success",
                    title: "Production saved successfully",
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                });
            }

            navigate("../UnusableProductionList");
        } catch (error) {
            console.error("Error saving/updating production:", error);
            Swal.fire({
                toast: true,
                icon: "error",
                title: "Error saving/updating production",
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
            });
        }
    };

    return (
        <div className="formcontainer mt-5">
            <div className="d-flex align-items-end mb-3">
                <button
                    className="btn btn-secondary btn-sm me-3"
                    onClick={() => navigate("../UnusableProductionList")}
                >
                    <FontAwesomeIcon icon={faChevronCircleLeft} /> Back
                </button>
                <h5>Unusable Production</h5>
            </div>
            <div className="container mt-4">
                <form onSubmit={handleSubmit}>
                    <div className="row mb-2">
                        <div className="col-md-3">
                            <label htmlFor="date" className="form-label">Date</label>
                            <input
                                type="date"
                                id="date"
                                className='form-control'
                                value={date}
                                onChange={(e) => setDate(e.target.value)}
                            />
                        </div>

                        <div className="col-md-3">
                            <label className="form-label">Department</label>
                            <Select
                                options={departments}
                                value={selectedDept}
                                onChange={(selectedOption) => {
                                    setSelectedDept(selectedOption);
                                    if (selectedOption) {
                                        fetchItemOptions([selectedOption.value]); // Wrap in array if your API expects multiple departments
                                    }
                                }}
                            />
                        </div>
                        <div className="col-md-3">
                            <label className="form-label">Location</label>
                            <Select
                                options={locations}
                                value={selectedLocation}
                                onChange={(selectedOption) => {
                                    setSelectedLocation(selectedOption);
                                }}
                            />
                        </div>
                        <div className="col-md-3">
                            <label htmlFor="remarks" className="form-label">Remarks</label>
                            <input
                                type="text"
                                id="remarks"
                                className='form-control'
                                value={remarks}
                                onChange={(e) => setRemarks(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="row fw-bold mb-2" style={{ fontSize: "15px" }}>
                            <div className="col-5">Item</div>
                            <div className="col-2">Qty</div>
                            <div className="col-1">UOM</div>
                            <div className="col-2">Remarks</div>
                            <div className="col-2">Actions</div>
                        </div>
                        {productionItems.map((f, index) => (
                            <div className="row align-items-center mb-1" key={index} style={{ fontSize: "15px" }}>
                                <div className="col-5">
                                    <Select
                                        options={itemOptions}
                                        value={f.item}
                                        onChange={(selected) => handleItemsChange(index, "item", selected)}
                                        styles={{ control: (base) => ({ ...base, minHeight: "30px", fontSize: "15px" }) }}
                                    />
                                </div>
                                <div className="col-2">
                                    <input
                                        type="number"
                                        className="form-control form-control-sm"
                                        value={f.quantity}
                                        onChange={(e) => handleItemsChange(index, "quantity", e.target.value)}
                                    />
                                </div>
                                <div className="col-1">
                                    <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        value={f.item?.uom || ""}
                                        disabled
                                    />
                                </div>
                                <div className="col-2">
                                    <input
                                        type="remarks"
                                        className="form-control form-control-sm"
                                        value={f.remarks}
                                        onChange={(e) => handleItemsChange(index, "remarks", e.target.value)}
                                    />
                                </div>
                                <div className="col-2 d-flex">
                                    <button type="button" className="btn btn-success btn-sm me-1" onClick={addRow}>
                                        <FontAwesomeIcon icon={faPlus} />
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-danger btn-sm"
                                        onClick={() => removeRow(index)}
                                        disabled={productionItems.length === 1}
                                    >
                                        <FontAwesomeIcon icon={faMinus} />
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* SAVE BUTTON */}
                    <div className="mt-3">
                        <button type="submit" className="btn btn-success btn-sm px-4">
                            {editId ? "Update" : "Save"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default UnusableProduction;
